import { render, staticRenderFns } from "./SettingsHeader.vue?vue&type=template&id=68bf0c0e&"
import script from "./SettingsHeader.vue?vue&type=script&lang=ts&"
export * from "./SettingsHeader.vue?vue&type=script&lang=ts&"
import style0 from "./SettingsHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports